import React, { useState, useRef, useEffect } from 'react';
import { InputGroup, FormControl } from 'react-bootstrap';
import { Search } from 'react-bootstrap-icons';
import { useSearchParams } from 'react-router-dom';
import Collapse from "react-bootstrap/Collapse";

export default function SearchField(props) {
	const { placeholder, title } = props;
	const [showOptions, setShowOptions] = useState(false);
	const [isColection, setisColection] = useState({
		active: false,
		value: '',
		repository:''
	});
	const [search] = useSearchParams();

	const wrapperRef = useRef(null);

	useOutsideAlerter(wrapperRef);

	const handleInputFocus = () => {
		if (!title) {
			return;
		}
		setShowOptions(true);
	};

	function useOutsideAlerter(ref) {
		useEffect(() => {
			/**
			 * Alert if clicked on outside of element
			 */
			function handleClickOutside(event) {
				if (ref.current && !ref.current.contains(event.target)) {
					setShowOptions(false);
				}
			}

			// Bind the event listener
			document.addEventListener('mousedown', handleClickOutside);
			return () => {
				// Unbind the event listener on clean up
				document.removeEventListener('mousedown', handleClickOutside);
			};
		}, [ref]);
	}

	useEffect(() => {
		let urlValue = search.get('nav');
		var valueToDefaultRadio = '';
		// ESTA DENTRO DE UNA COLECCION
		if (!urlValue) {
			valueToDefaultRadio = title === 'Fototeca Guatemala' ? 'CIRMA-FG' : 'CIRMA-AH';
			setisColection((prev)=>({...prev,value: valueToDefaultRadio}));
			return;
		}
		// ESTA DENTRO DE UNA COLECCION
		let repository = urlValue.includes('GT-CIRMA-FG') ? 'CIRMA-FG' : 'CIRMA-AH';
		setisColection({ active: true, value: urlValue,repository:repository });
	}, [search, title]);

	return (
		<div className='c-input-search' ref={wrapperRef}>
			<form action={`/search`}>
				<InputGroup className='mb-3'>
					<FormControl
						placeholder={placeholder}
						aria-label={placeholder}
						aria-describedby='basic-addon2'
						onFocus={handleInputFocus}
						name='keywords'
						autoComplete='off'
					/>
					<button className='btn'>
						<InputGroup.Text id='basic-addon2'>
							<Search />
						</InputGroup.Text>
					</button>
				</InputGroup>
				<Collapse in={showOptions}>
					<div className={`card options_box`}>
						<div className='card-body d-inline-grid option'>
							<input
								className='form-check-input'
								name={'repository'}
								type='hidden'
								id='defaultAgenciBox'
								defaultChecked={!isColection.active}
								defaultValue={isColection.active?isColection.repository:isColection.value}
							/>
							<div className='form-check me-md-3'>
								<input
									className='form-check-input boxOption'
									name={isColection.active?'isadg':'repository'}
									type='radio'
									defaultValue={''}
									onClick={(e)=>{
										if (e.target.checked) {
											document.getElementById('defaultAgenciBox').setAttribute('disabled','disabled');
											return;
										}
										document.getElementById('defaultAgenciBox').removeAttribute('disabled');
									}}
									id='allCirmaOption'
								/>
								<label className='form-check-label'htmlFor='allCirmaOption'>
									Buscar en todo CIRMA
								</label>
							</div>
							{isColection.active && (
								<div className='form-check me-md-3'>
									<input
										className='form-check-input boxOption'
										name='isadg'
										type='radio'
										defaultChecked={isColection.active}
										defaultValue={isColection.value}
										id='AllColectionBox'
									/>
									<label
										className='form-check-label'
										htmlFor='AllColectionBox'>
										Buscar en esta colección
									</label>
								</div>
							)}
						</div>
					</div>
				</Collapse>
			</form>
		</div>
	);
}
